module.exports = __webpack_public_path__ + "static/media/wizualizacja-6.25ea733e.png";